var loader = function (callback) {
    // var _count = 20;
    // loadProces(_count);
    $("img").one("load", function () {
        // var len = document.getElementsByTagName('img').length;
        // console.log('len', len)
        // loadProces(_count += (79 / len));
    });

    // if ( !$('.h_slider-js').length ) {
    //     setTimeout(function () {
    //         loadProces(100);
    //         callback();
    //         $('.loader').addClass('hide');
    //     }, 10)
    // }

    // setTimeout(function () {
    //     loadProces(100);
    //     callback();
    //     $('.loader').addClass('hide');
    //     if (h_benefits && h_benefits.length) {
    //         h_benefits.reloadSlider();
    //     }
    //     else {
    //         setTimeout(function () {
    //             if (h_benefits && h_benefits.length) {
    //                 h_benefits.reloadSlider();
    //             }
    //         }, 1000)
    //     }
    //     if (h_about && h_about.length) {
    //         h_about.reloadSlider();
    //     } else {
    //         setTimeout(function () {
    //             if (h_about && h_about.length) {
    //                 h_about.reloadSlider();
    //             }
    //         }, 1000)
    //     }
    //     if (innerWidth < 700) {
    //         if (h_slider && h_slider.length) {
    //             h_slider.reloadSlider();
    //         } else {
    //             setTimeout(function () {
    //                 if (h_slider && h_slider.length) {
    //                     h_slider.reloadSlider();
    //                 }
    //             }, 1000)
    //         }
    //     }
    // }, 10);
    window.onload = function () {
        loadProces(100);
        callback();
    };
    function loadProces(_count) {
        $('.loader_text').each(function () {
            $(this).stop().prop('Counter', $(this).text()).animate({
                Counter: _count,
            }, {
                // duration: 1000,
                step: function (now) {
                    if (now == 100) {
                        $('.loader').addClass('hide');
                    }
                    $('.loader_line').width(Math.ceil(now) + '%');
                    $('.loader_status_in').height(100 - Math.ceil(now) + '%');

                    $(this).text(Math.ceil(now));
                },
            });
        });
        setTimeout(function () {
            docScroll = window.scrollY;
            console.log(docScroll)
            headerStyle();
            $('.anim').each(function () {
                if ($(this).offset().top < docScroll + innerHeight / 1.5) {
                    $(this).addClass('open')
                }
            })

            if (scrollY > innerHeight) {
                $('.to_top').addClass('show');
            }
            else {
                $('.to_top').removeClass('show');
            }
        }, 500)
    }
}

var tablet = function (callback) {
    if (innerWidth < 1200) {
        callback()
    }
}
